"use client";

import { PropsWithChildren } from "react";
import { MaintenancePage } from "./MaintenancePage";
import { useMaintenanceStatus } from "@/hooks/maintenance/useMaintenanceStatus";

export function MaintenanceWrapper({ children }: PropsWithChildren) {
  const { isMaintenanceMode } = useMaintenanceStatus();

  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }

  return <>{children}</>;
}
